// extracted by css-extract-rspack-plugin
export default {"container":"NNkUjjey4OIe32kI__container___","pageWrapper":"SkeWiMisv7MkOE7l__pageWrapper___"};